import React from "react";
import "./Portfolio.scss";
import Title from "../../components/Title/Title";
import PortfolioCardItem from "./components/portfolioCardItem/PortfolioCardItem";
const Portfolio = () => {
  return (
    <div className="portfolio">
      <Title heading={"Portfolio"} />
      <div className="page-container">
        <div className="row works">
          <PortfolioCardItem />
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
